import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-euc-odbery-krve",
  "use": "icon-euc-odbery-krve-usage",
  "viewBox": "0 0 42.52 42.52",
  "content": "<symbol viewBox=\"0 0 42.52 42.52\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-euc-odbery-krve\"><circle cx=\"21.26\" cy=\"21.26\" fill=\"none\" r=\"20.26\" stroke=\"currentColor\" stroke-width=\"1\" /><path d=\"m31.91 25.05a10.86 10.86 0 0 1 -21.72 0c.06-9.3 10.81-18.44 10.81-18.44s10.9 8.97 10.91 18.44z\" fill=\"currentColor\" /><g fill=\"none\"><path d=\"m16.79 18.93h3v-3h2.51v3h3v2.52h-3v3h-2.52v-3h-3z\" /><path d=\"m17.76 27.71h6.58v2.46h-6.58z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol